"use strict"

angular.module("core")
.service("OrderStatusService", function($resource, FlashBag, appConfig) {
    var resourceStatusNameTranslations = $resource(appConfig.API_SERVER + "/catalog/order/status-names/translations/", {}, {
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    var resourceStatusNameFilters = $resource(appConfig.API_SERVER + "/catalog/order/status-names/filters/", {}, {
        query: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor},
            isArray: true
        }
    });

    this.getStatusNamesTranslations = function() {
        return resourceStatusNameTranslations.get();
    }

    this.getStatusNameFilters = function() {
        return resourceStatusNameFilters.query();
    }

    this.query = function(filter) {
        var filterParams = filter ? filter : {};
        return resourceStatusNameFilters.query(filterParams);
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/order/order-status.service.js
// module id = 434
// module chunks = 0